import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsVerified, useSetIsVerified } from '../../state';
import fetchWithToken from '../../services';

const CheckVerificationStatus = () => {
    const isVerified = useIsVerified();
    const setIsVerified = useSetIsVerified();
    const navigate = useNavigate();

    useEffect(() => {
        const checkVerificationStatus = async () => {
            try {
                const response = await fetchWithToken('/check-verification-status', {
                    method: 'GET'
                });
                
                // Clone the response so we can use it multiple times
                const responseClone = response.clone();
                
                // Log response metadata
                console.log('Response metadata:', {
                    status: response.status,
                    ok: response.ok,
                    headers: Object.fromEntries([...response.headers.entries()])
                });
                
                // Get the raw text to see what's actually being returned
                responseClone.text().then(rawText => {
                    console.log('Raw response body:', rawText);
                    try {
                        // Try to parse it manually to see if it's valid JSON
                        const manualParse = JSON.parse(rawText);
                        console.log('Manually parsed JSON:', manualParse);
                    } catch (parseError) {
                        console.error('Raw response is not valid JSON:', parseError);
                    }
                });
                
                // Try to parse as JSON using the original response
                const data = await response.json();
                console.log('returned from check-verification-status: ', data);

                if (data.isVerified === true) {
                    setIsVerified(true);
                } else {
                    setIsVerified(false);
                }
            } catch (error) {
                console.error('Error checking if user is verified:', error);
                setIsVerified(false);
            }
        };

        checkVerificationStatus();
    }, []);

    useEffect(() => {
        if (isVerified !== null) {
            navigate('/');
        }
    }, [isVerified]);

    return null;
};

export default CheckVerificationStatus;
